import React, { useEffect, useState } from 'react'
import Home from './Home'

import { useSpotify } from '../../hoc/context/SpotifyContextContainer'
import { makeSpotifyRequest } from '../../config/SpotifyRequests'
import {GetPlayer} from '../../hoc/Layout/Layout'


import Loader from '../loader/Loader'

function HomeContainer(props) {
    const {accessToken} = useSpotify()
    const [ featured, setFeatured ] = useState([])
    const [ weekFeature, setWeekFeature ] = useState([])
    const { pid, setPid } = GetPlayer()

    const [ render, setRender ] = useState(false)

    useEffect(async () => {
        try {
            let res = await makeSpotifyRequest(`https://api.spotify.com/v1/me/top/tracks?limit=10` , accessToken);
            setFeatured(res.data.items)
            
            if(!pid)
            setPid(res.data.items[0].id)

            res = await makeSpotifyRequest(`https://api.spotify.com/v1/browse/featured-playlists?country=MA&limit=9`, accessToken)
            setWeekFeature(res.data.playlists.items)

            setRender(true)
        }catch(e){
            
        }
    }, [accessToken])

    return (
        <>
           { render && <Home featured={featured} playlists={weekFeature}/>}
           { !render && <Loader /> }
        </>
    )
}

export default HomeContainer

